// extracted by mini-css-extract-plugin
module.exports = {"card":"Workout_card__11RAz","description":"Workout_description__2UjMX"};